import React from "react";
import brand from "../db/brand";

const Pulse = () => (
  <div className="pulse">
    {brand.pulse.map((p) => (
      <div key={p.title} className="item">
        <div className="date">{p.d}</div>
        <div className="title">{p.title}</div>
        <div className="tag-mini">{p.tag}</div>
      </div>
    ))}
  </div>
);

export default Pulse;
